import { OnboardingKeys } from './onboarding-state/onboarding-constants.ts';
import { ContextualInviteNudgeOnboardingKeys } from './onboarding-state/onboarding-contextual-invite-nudge.ts';
import { EditorOnboardingKeys } from './onboarding-state/onboarding-editor-constants.ts';
import { FeedOnboardingKeys } from './onboarding-state/onboarding-feed-constants.ts';
import { HomeTakeoverOnboardingKeys } from './onboarding-state/onboarding-home-takeover-constants.ts';
import { InsightsOnboardingKeys } from './onboarding-state/onboarding-insights-constants.ts';
import { LandInSpampleSpaceOnboardingKeys } from './onboarding-state/onboarding-land-in-sample-space.ts';
import { LiveDocsOnboardingKeys } from './onboarding-state/onboarding-live-docs-constants.ts';
import { SpaceMissionControlOnboardingKeys } from './onboarding-state/onboarding-mission-control-constants.ts';
import { PersonalizedTemplatesOnboardingKeys } from './onboarding-state/onboarding-personalized-templates-constants.ts';
import { PresenceAdminFeedbackSurveyOnboardingKeys } from './onboarding-state/onboarding-presence-admin-feedback-survey.ts';
import { RoleBasedAccessControlOnboardingKeys } from './onboarding-state/onboarding-role-based-access-control.ts';
import { RovoVideoPlayerStateOnboardingKeys } from './onboarding-state/onboarding-rovo-video-player-constants.ts';
import { ShareAndRestrictDialogOnboardingKeys } from './onboarding-state/onboarding-share-and-restrict-dialog-constants.ts';
import { StorageEnforcementOnboardingKeys } from './onboarding-state/storage-enforcement/storage-enforcement-constants.ts';
import { TrialComponentsOnboardingKeys } from './trial-components/trial-components-constants.ts';
import { CreateIntroFirstStepOnboardingStateKeys } from './onboarding-state/onboarding-create-intro-first-step-constants.ts';
import { NewContentHistoryOnboardingStateKeys } from './onboarding-state/onboarding-new-content-history.ts';
import { AIFCOnboardingKeys } from './onboarding-state/onboarding-afic-onboarding.ts';
import { NthUserHomeOnboardingRevampKeys } from './onboarding-state/onboarding-home-revamp-constants.ts';
import { ExportJiraContextToPageTourKeys } from './onboarding-state/onboarding-export-jira-context-to-page-constants.ts';
import { ConfluenceRecapOnboardingKeys } from './onboarding-state/onboarding-confluence-recap-constants.ts';
import { SnippetsOnboardingKeys } from './onboarding-state/onboarding-snippets-constants.ts';
import { SuggestWhiteboardBasedOnPageTitleOnboardingKeys } from './onboarding-state/onboarding-suggest-whiteboard-based-on-page-title.ts';
import { SuggestSkillBasedOnPageTitleOnboardingKeys } from './onboarding-state/onboarding-suggest-skill-based-on-page-title.ts';
import { SuggestAgentBasedOnPageTitleOnboardingKeys } from './onboarding-state/onboarding-suggest-agent-based-on-page-title.ts';
import { SmartLinkDraggableOnboardingKeys } from './onboarding-state/onboarding-smart-link-draggable.ts';
import { ChangeboardingAdminNavTourOnboardingKeys } from './onboarding-state/onboarding-changeboarding-admin-nav-tour-constants.ts';
import { Twcg1489ConnectorOnboardingKeys } from './onboarding-state/onboarding-twcg-1489-connector-onboarding-constants.ts';
import { UniversalCreateCwRExperimentSpotlightOnboardingKeys } from './onboarding-state/onboarding-universal-create-cwr-experiment-spotlight-constants.ts';
import { MeetingsPillNewLozengeOnboardingKeys } from './onboarding-state/onboarding-meetings-pill-constants.ts';
import { MeetingsOnboardingKeys } from './onboarding-state/onboarding-meetings-onboarding-constants.ts';

export const OnboardingKeysCombined: readonly (
	| 'aifc-onboarding:hasSeenAIFCSpotlight'
	| 'aifc-onboarding:isAIFCSpotlightActive'
	| 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight'
	| 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight'
	| 'aifc-onboarding:isAIFCChatSpotlightActive'
	| 'aifc-onboarding:hasSeenAIFCChatSpotlight'
	| 'aifc-onboarding:hasDismissedGettingStartedTour'
	| 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight'
	| 'aifc-onboarding:hasSeenTwcAifcOnboarding'
	| 'changeboarding-admin-nav-tour:tourSeen'
	| 'confluence-recap:hasSeenPublishSpotlight'
	| 'random:ExportJiraContextToPage:tourCompleted'
	| 'random:ExportJiraContextToPage:tourDismissed'
	| 'onboarding-popular-feed-card:isDismissed'
	| 'nth-user-home-onboarding-revamp:onboardingActionStates'
	| 'nth-user-home-onboarding-revamp:areAllActionsDismissed'
	| 'nth-user-home-onboarding-revamp:takeoverSeenAt'
	| 'nth-user-home-onboarding-revamp:isTemplateListDismissed'
	| 'nth-user-home-onboarding-revamp:templateUsageValues'
	| 'storage-enforcement-state:flagsDismissedFreeThreshold'
	| 'onboarding-intent-experiences:onboardingIntentExperienceClosed'
	| 'onboarding-intent-experience:isOnboardingExperienceEligibleUser'
	| 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt'
	| 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
	| 'onboarding-reverse-trial:isModalSeen'
	| 'templates-collection:isTaggedForTemplatesCollectionExperiment'
	| 'templates-collection:isTemplatesSectionDismissed'
	| 'space-getting-started-tour:tourIsDismissed'
	| 'persistent-invite:hasInviteCapabilities'
	| 'nav4:isNav4GlobalSpotlightDismissed'
	| 'nav4:isNav4SpaceTourDismissed'
	| 'nav4:isNav4CollapseReminderSpotlightDismissed'
	| 'creation-focused-nav:shouldShowSpotlight'
	| 'creation-focused-nav:startTime'
	| 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed'
	| 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
	| 'create-with-rovo-announcement-splash:hasSeenSplashModal'
	| 'welcome-from-rovo:chatAutoOpened'
	| 'nth-user-setup:nthUserSelectedContentType'
	| 'nth-user-setup:nthUserContentTypeSpotlightSeen'
	| 'nth-user-setup:nthUserContentTypePopularContentFound'
	| 'nth-user-setup:nthUserContentTypeLandingContentId'
	| 'prompt-whiteboard-competitor-link:isPromptDismissed'
	| 'prompt-database-competitor-link:isPromptDatabaseDismissed'
	| 'onboarding-state:introWorkflow'
	| 'onboarding-state:legacy'
	| 'onboarding-state:isFoundingAdmin'
	| 'onboarding-state:isSampleContentV2SpotlightVisible'
	| 'onboarding-state:landOnPath'
	| 'onboarding-state:teamSpaceCreated'
	| 'onboarding-state:isMoreActionsTourVisible'
	| 'onboarding-state:isMoreActionsHintVisible'
	| 'onboarding-state:improvedGetStartedPath'
	| 'onboarding-state:improvedGetStartedWhiteboardPath'
	| 'onboarding-state:isRedactionsTourVisible'
	| 'onboarding-state:xflowSpaceCreated'
	| 'onboarding-state:templateOnboardingViewedTime'
	| 'onboarding-state:nthUserOnboardingCompletedTimestamp'
	| 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
	| 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
	| 'use-cases-nth-user-onboarding:selectedTemplates'
	| 'use-cases-nth-user-onboarding:viewedAt'
	| 'use-cases-nth-user-onboarding:headerDismissed'
	| 'use-cases-nth-user-onboarding:headerViewedAt'
	| 'auto-page-emoji:emojiTitleDiscovered'
	| 'simplify-nav-new-user:nthUserD0SimplifiedNavEligible'
	| 'creation-focused-nav-xflow:creationFocusedNavXflowCheckedEligible'
	| 'creation-focused-nav-xflow:creationFocusedNavXflowStartAt'
	| 'cross-join-nth-user-onboarding:trendingPages'
	| 'cross-join-nth-user-onboarding:dismissed'
	| 'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag'
	| 'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen'
	| 'editor-state:editorOnboardingEligiblity'
	| 'editor-state:editorVisited'
	| 'editor-state:wasDraftBannerSeen'
	| 'editor-state:isDraftBannerVisible'
	| 'editor-state:isLandInEditorBannerVisible'
	| 'editor-state:hasUserPublished'
	| 'editor-state:successFlagCompleted'
	| 'editor-state:recentSpotlightOpen'
	| 'editor-state:recentSpotlightCompleted'
	| 'editor-state:editorTutorialSuccessFlagCompleted'
	| 'editor-state:wasEditorConversionModalSeen'
	| 'editor-state:wasEditorConversionModalV3Seen'
	| 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint'
	| 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint'
	| 'onboarding-insights:hasContextualFloatingButtonBeenSeen'
	| 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen'
	| 'onboarding-insights:hasAudioV3ChangeboardingBeenSeen'
	| 'onboarding-insights:hasFloatingTableOfContentsBeenInteractedWith'
	| 'space-mission-control-onboarding:spaceSettingsChangeboardingFirstSeenAt'
	| 'space-mission-control-onboarding:spaceSettingsChangeboardingDismissedAt'
	| 'presence-feedback-survey:hasAdminSeenFeedbackSurvey'
	| 'RoleBasedAccessControl:usersTableSpotlightSeen'
	| 'RoleBasedAccessControl:defaultsRoleTableModalSeen'
	| 'RoleBasedAccessControl:gaInProductOnboardingFlagSeen'
	| 'RoleBasedAccessControl:defaultRoleTableSpotlightSeen'
	| 'RoleBasedAccessControl:customRolePageSpotlightSeen'
	| 'onboarding-rovo-video-player:rovoVideoPlayerSeen'
	| 'random:ShareAndRestrictDialog:spotlightSeen'
	| 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen'
	| 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen'
	| 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen'
	| 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
	| 'trial-components:actionMenuOpened'
	| 'trial-components:dismissedTrial1DayFlag'
	| 'trial-components:dismissedTrial3DayFlag'
	| 'trial-components:dismissedPredunning0DayFlag'
	| 'trial-components:dismissedPredunning1DayFlag'
	| 'trial-components:dismissedPredunning2DayFlag'
	| 'trial-components:dismissedPredunning3DayFlag'
	| 'trial-components:dismissedTrialUnhandledDayFlag'
	| 'personalized-templates-v2:onboardingActionStates'
	| 'personalized-templates-v2:hasDismissedOnboardingActions'
	| 'personalized-templates-v2:takeoverSeenAt'
	| 'personalized-templates-v2:isTemplateListDismissed'
	| 'personalized-templates-v2:templateUsageValues'
	| 'live-page-nudge:wasLivePageNudgeSeen'
	| 'live-page-nudge:livePageNudgeInviteIneligible'
	| 'home-onboarding-takeover-v2:hasSeenHomeNudge'
	| 'home-onboarding-takeover-v2:isHomeNudgeScheduledAt'
	| 'home-onboarding-takeover-v2:takeoverSeenAt'
	| 'home-onboarding-takeover-v2:onboardingActionStates'
	| 'home-onboarding-takeover-v2:isCollapsed'
	| 'home-onboarding-takeover-v2:hasSeenConfetti'
	| 'home-onboarding-takeover-v2:hasDismissedCarousel'
	| 'home-onboarding-takeover-v2:hasDismissedLearningResources'
	| 'home-onboarding-takeover-v2:hasDismissedTakeover'
	| 'land-in-sample-space:hasDismissedBanner'
	| 'land-in-sample-space:hasSeenSampleContentFlag'
	| 'create-intro-first-step:headerSeenAt'
	| 'create-intro-first-step:headerCompleted'
	| 'create-intro-first-step:headerDismissed'
	| 'new-content-history-onboarding:hasSeenSpotlight1'
	| 'suggest-whiteboard-based-on-page-title:hasDismissedFlowChart'
	| 'suggest-whiteboard-based-on-page-title:hasDismissedBrainstorming'
	| 'suggest-whiteboard-based-on-page-title:hasDismissedRetro'
	| 'suggest-whiteboard-based-on-page-title:hasDismissedProductRoadmap'
	| 'suggest-whiteboard-based-on-page-title:hasDismissedPrioritizationMatrix'
	| 'suggest-whiteboard-based-on-page-title:hasDismissedOrgChart'
	| 'suggest-whiteboard-based-on-page-title:hasDismissedStickyNotePack'
	| 'suggest-whiteboard-based-on-page-title:hasDismissedAllTemplateSuggestions'
	| 'suggest-skill-based-on-page-title:hasDismissedWritePrd'
	| 'suggest-skill-based-on-page-title:hasDismissedWriteHowToArticle'
	| 'suggest-skill-based-on-page-title:hasDismissedResearchInsights'
	| 'suggest-skill-based-on-page-title:hasDismissedCreateActionPlan'
	| 'suggest-skill-based-on-page-title:hasDismissedAllSkillSuggestions'
	| 'suggest-agent-based-on-page-title:hasDismissedPlannerOnce'
	| 'suggest-agent-based-on-page-title:hasDismissedPlannerPermanently'
	| 'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackOnce'
	| 'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackPermanently'
	| 'suggest-agent-based-on-page-title:hasShownTechWriterContentIds'
	| 'suggest-agent-based-on-page-title:catalogState'
	| 'snippets:hasSeenFirstSnippetCreatedModal'
	| 'snippets:hasSeenSnippetsTabSpotlight'
	| 'smart-link-draggable:changeboardViewed'
	| 'twcg-1489:enrolmentDate'
	| 'twcg-1489:spotlightShown'
	| 'twcg-1489:promoDismissed'
	| 'universal-create-cwr-experiment-spotlight:hasSeenUniversalCreateCwRExperimentSpotlight'
	| 'meetings-pill-new-lozenge:firstSeenAt'
	| 'meetings-pill-new-lozenge:clickCount'
	| 'twcg-2202-loom-nudge:remindMe'
	| 'twcg-2202-loom-nudge:lastShownAt'
	| 'meetings-onboarding:retired'
)[] = [
	...StorageEnforcementOnboardingKeys,
	...OnboardingKeys,
	...ContextualInviteNudgeOnboardingKeys,
	...EditorOnboardingKeys,
	...InsightsOnboardingKeys,
	...SpaceMissionControlOnboardingKeys,
	...PresenceAdminFeedbackSurveyOnboardingKeys,
	...RoleBasedAccessControlOnboardingKeys,
	...RovoVideoPlayerStateOnboardingKeys,
	...ShareAndRestrictDialogOnboardingKeys,
	...TrialComponentsOnboardingKeys,
	...PersonalizedTemplatesOnboardingKeys,
	...LiveDocsOnboardingKeys,
	...HomeTakeoverOnboardingKeys,
	...FeedOnboardingKeys,
	...LandInSpampleSpaceOnboardingKeys,
	...CreateIntroFirstStepOnboardingStateKeys,
	...NewContentHistoryOnboardingStateKeys,
	...AIFCOnboardingKeys,
	...NthUserHomeOnboardingRevampKeys,
	...ExportJiraContextToPageTourKeys,
	...ConfluenceRecapOnboardingKeys,
	...SuggestWhiteboardBasedOnPageTitleOnboardingKeys,
	...SuggestSkillBasedOnPageTitleOnboardingKeys,
	...SuggestAgentBasedOnPageTitleOnboardingKeys,
	...SnippetsOnboardingKeys,
	...SmartLinkDraggableOnboardingKeys,
	...ChangeboardingAdminNavTourOnboardingKeys,
	...Twcg1489ConnectorOnboardingKeys,
	...UniversalCreateCwRExperimentSpotlightOnboardingKeys,
	...MeetingsPillNewLozengeOnboardingKeys,
	...MeetingsOnboardingKeys,
] as const;

export type OnboardingKeysCombinedType = (typeof OnboardingKeysCombined)[number];
